module.exports = __webpack_public_path__ + "media/images/top/seminars/top/img_kv-f6e3600ac690c97d5896bc1368d09ec5.jpg";